module.exports = __webpack_public_path__ + "static/media/2.15_preview.3e9a765d.png";